import React from 'react';
import { useHistory, useParams } from 'react-router';
import AntdProForm from '@ant-design/pro-form';
import { message } from 'antd';
import moment from 'moment';
import { useMutation } from '@apollo/client';
import ProfileInfo from './components/ProfileInfo';
import ExtensionForm from './ExtensionForm';
import ProjectHeader from '../ProjectHeader';
import { ADD_EXTENSION, GET_EXTENSIONS } from '../../../gql/extensions';
import ExtensionStep from './components/ExtensionSteps';
import fp from 'lodash/fp';
import { PageContainer } from '@ant-design/pro-layout';
import { useProjectFrozen } from 'hooks';

const getId = fp.map(({ id }) => id);

const AddExtension = () => {
  const { projectId } = useParams();
  const projectFrozen = useProjectFrozen(projectId);
  const [form] = AntdProForm.useForm();
  const history = useHistory();
  const [addExtension] = useMutation(ADD_EXTENSION, {
    refetchQueries: [
      {
        query: GET_EXTENSIONS,
        variables: {
          projectIds: [projectId],
          status: ['DRAFT', 'PENDING', 'REJECTED', 'APPROVED', 'VOIDED'],
        },
      },
    ],
  });

  const onFinish = async ({
    newCompletionDate,
    justification,
    progressReport,
    supplements,
  }) => {
    try {
      const {
        data: {
          addExtension: { id },
        },
      } = await addExtension({
        variables: {
          input: {
            projectId,
            newCompletionDate: moment(newCompletionDate).format('YYYY-MM-DD'),
            progressReport: progressReport[0].id,
            justification: justification,
            supplements: getId(supplements),
          },
        },
      });
      message.success('Extension saved');
      history.push(`/projects/${projectId}/extensions/${id}`);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <ProjectHeader>
      <PageContainer>
        <ExtensionStep current={0} />
        <ProfileInfo />
        <ExtensionForm
          form={form}
          onFinish={onFinish}
          projectFrozen={projectFrozen}
        />
      </PageContainer>
    </ProjectHeader>
  );
};

export default AddExtension;
